import { useQuery, UseQueryOptions } from "@tanstack/react-query";

import { getReimbursementReport } from "~/providers/api";
import { ConsultationReimbursementReport } from "~/providers/utils/types/consultation";

export const useGetReimbursementReport = (
  consultationId?: string,
  options?: Partial<
    UseQueryOptions<ConsultationReimbursementReport | null, Error>
  >,
) => {
  return useQuery({
    queryFn: () => getReimbursementReport(consultationId),
    queryKey: ["getReimbursementReport", consultationId],
    enabled: !!consultationId,
    ...options,
  });
};
